function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result
        ? {
              r: Number.parseInt(result[1], 16),
              g: Number.parseInt(result[2], 16),
              b: Number.parseInt(result[3], 16)
          }
        : null
}

export function isLightHexColor(hex: string): boolean {
    const rgb = hexToRgb(hex)
    if (!rgb) return true

    const { r, g, b } = rgb
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.5
}

export function getContrastColor(backgroundColor: string): string {
    return isLightHexColor(backgroundColor) ? '#000000' : '#ffffff'
}

/**
 * Text color for filled primary buttons (typically primary-600 background).
 * Saturated/dark primaries use the widget background (e.g. white on teal).
 * Light primaries on light widgets do the same so labels do not inherit theme body text.
 */
export function resolveWidgetTextOnPrimary(
    buttonBackgroundColor: string,
    widgetBackgroundColor: string,
    explicitOverride?: string
): string {
    if (explicitOverride) {
        return explicitOverride
    }

    if (!isLightHexColor(buttonBackgroundColor)) {
        return widgetBackgroundColor
    }

    if (!isLightHexColor(widgetBackgroundColor)) {
        return getContrastColor(buttonBackgroundColor)
    }

    return widgetBackgroundColor
}
